<template>
    <div class="post-meta uppercase text-white text-xs leading-10">
        <!--Category-->
        <tis-button
            :class="{'border-gold-500 text-gold-500 hover:text-white hover:border-white': inListFormat}"
            :url="getBlogPostProperty('postCategory', 'url')"
            class="category-name transition-all border rounded-sm border-white p-3 mr-3 tablet:mr-6 inline-block mb-2 hover:text-gold-500 hover:border-gold-500"
            v-text="getBlogPostProperty('postCategory', 'name')" />
        <div class="inline-block">
            <!--Date -->
            <span
                class="article-date"
                v-html="getBlogPostProperty('postMeta', 'published_at_formatted')" />
            <!--Bullet point in between added via CSS via :before element-->
            <!--Reading Time-->
            <span
                v-if="getBlogPostProperty('postMeta', 'estimated_reading_time')"
                class="reading-time"
                v-html="getBlogPostProperty('postMeta', 'estimated_reading_time')" />
        </div>
    </div>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';
import { get } from 'lodash';

export default {
  name: 'PostMeta',
  components: { TisButton },
  props: {
    inListFormat: {
      type: Boolean,
      required: false,
    },
    postCategory: {
      type: Object,
      required: true,
    },
    postMeta: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBlogPostProperty(group, property) {
      return get(this, [group, property]);
    },
  },
};
</script>

<style scoped>
    .reading-time:before {
        content: '• ';
        margin-left: .5rem;
        margin-right: .5rem;
    }
</style>
